import { FC } from 'react'

import { IconButton } from '@/compositions/@buttons/IconButton/IconButton'
import { trans } from '@/helpers/trans'

import './SkipButton.scss'

interface SkipButtonProps {
    onClick?: () => void
    className?: string
}

export const SkipButton: FC<SkipButtonProps> = ({ onClick, className = '' }) => (
    <IconButton
        icon="chevron-right"
        iconPos="right"
        text={trans('common.skip')}
        onClick={onClick}
        className={`skip-button ${className}`}
        iconClassName="skip-button__icon"
    />
)
